import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

import LiberaProfessioneWidget from "./LiberaProfessione";
import MinimaliMassimaliWidget from "./MinimaliMassimali";
import data from "../../../../data/professioni.json";
import _ from "lodash";

// IBRIDO
const IbridoWidget = ({
  fatturato,
  setContributiTotali,
  contributiTotali,
  riduzioneContributi,
  redditoPrevidenziale,
  isFullTime,
  setIbridoCase,
  parameters,
}) => {
  const [active, setActive] = useState(0);

  let professioneIndex = _.findKey(data.professioni, function (o) {
    return o.id === parseInt(parameters.professione);
  });
  const selected = data.professioni[professioneIndex];
  const choices = selected.tipologia;

  const indexProfessionistaLabel = _.findIndex(
    choices,
    (choice) => choice === "Professionista"
  );
  choices.unshift(choices.splice(indexProfessionistaLabel, 1)[0]);

  const animation = {
    initial: {
      opacity: 0,
      position: "absolute",
    },
    animate: {
      opacity: 1,
      position: "relative",
    },
    exit: {
      opacity: 0,
      position: "absolute",
    },
  };

  const handleClick = (index) => {
    setActive(index);
    setIbridoCase(index);
  };

  useEffect(() => {
    if (parameters.ibridoCase !== undefined) {
      setActive(parseInt(parameters.ibridoCase));
    }
  }, [parameters.ibridoCase]);

  return (
    <div>
      <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-x-4 text-left">
        Il codice ATECO della tua professione prevede la possibilità di
        scegliere tra due possibili regimi contributivi
        <div className="flex flex-row gap-x-4 pt-4 pb-4 md:pb-0 md:pt-0">
          {choices.map((choice, index) => {
            return (
              <button
                key={choice}
                onClick={() => handleClick(index)}
                style={{ border: "1px solid orange" }}
                className={`${
                  active === index
                    ? "bg-orange-400 text-white"
                    : "bg-white text-orange-400"
                } border border-orange-400 duration-75 pl-[1em] pr-[1em] rounded-md  pt-[0.5em] pb-[0.5em]`}
              >
                {choice}
              </button>
            );
          })}
        </div>
      </div>

      <div className="relative">
        <AnimatePresence>
          {active ? (
            <motion.div
              key={"gestione-commercianti-artigiani"}
              variants={animation}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <MinimaliMassimaliWidget
                fatturato={fatturato}
                contributiTotali={contributiTotali}
                setContributiTotali={setContributiTotali}
                riduzioneContributi={riduzioneContributi}
                redditoPrevidenziale={redditoPrevidenziale}
                isFullTime={isFullTime}
                parameters={parameters}
              />
            </motion.div>
          ) : (
            <motion.div
              key={"gestione-liberi-professionisti"}
              variants={animation}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <LiberaProfessioneWidget
                contributiTotali={contributiTotali}
                setContributiTotali={setContributiTotali}
                redditoPrevidenziale={redditoPrevidenziale}
                isFullTime={isFullTime}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default IbridoWidget;
